export const GET_INSURERS = {
  START: "INSURERS/GET_INSURERS_START",
  SUCCESS: "INSURERS/GET_INSURERS_SUCCESS",
  ERROR: "INSURERS/GET_INSURERS_ERROR",
  CLEAR: "INSURERS/CLEAR_INSURERS",
};
